import { CmsApiFlashCardQuizBlockData } from 'modules/cms/api/types/blocks/CmsApiFlashCardQuizBlock';
import { CmsAmpHeroBlock } from 'modules/cms/blocks/Amp/Hero';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpFlashCardQuizBlock({
  content,
  data,
  blockId,
}: CmsAmpBlockMappingComponentProps<CmsApiFlashCardQuizBlockData>) {
  return (
    <CmsAmpHeroBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        text: data.cards[0].question,
        image: data.cards[0].image,
        buttonText: getText('View Quiz'),
      }}
    />
  );
}
